.AnimationContainer
    overflow: hidden

.ArticleContainer
    width: 100%
    margin: 0
    padding: 0
    color: rgb($globalSettingsFontPrimary)
    display: flex
    align-items: center
    justify-content: space-between
    clear: both
    box-sizing: border-box

.LeftContainer
    display: flex
    flex-direction: row
    align-items: center
    max-width: 70%
    gap: 10px
    .ArticleInfo
        display: flex
        flex-direction: column
        font-size: 14px
        cursor: pointer
        span.title
            font-weight: 700
    .ImageIcon
        width: 40px
        min-width: 40px
        height: 40px
        min-height: 40px
        border-radius: $globalButtonRounding
    .ImageIconMileage
        fill: rgb($globalSettingsBackgroundPrimary)
        stroke: rgb($globalSettingsFontTertiary)

.RightContainer
    display: flex
    flex-direction: column
    align-items: flex-end
    margin-left: 10px
    max-width: 50%
    gap: 5px
    flex-shrink: 0

.MileageEdit
    cursor: pointer
    text-decoration: underline
    &:hover
        color: rgb($globalSettingsFontSecondary)

.Pointer
    cursor: pointer
